import { ExtendedOrderCache } from '../../../lib/cache/ExtendedOrderCache';
import { useTenant } from '@parcel2go/npm-p2g-app';
import { SettingsCache } from '~/lib/consts/settings-cache';
import { backgroundTaskSwrConfig, requireBackgroundTaskSuccess } from './background-task-config';
import useBackgroundTaskFetch from './useBackgroundTaskFetch';
import { GetRefundsResponse, Refund } from '~/lib/api/me/types';
import { getApiPath } from '~/lib/api/me/get-api-path';
import useSWR from 'swr';
import { useEffect } from 'react';

const useSupportBackgroundTask = () => {
  const { tenant } = useTenant();
  const backgroundFetch = useBackgroundTaskFetch();

  const { data } = useSWR<Refund[]>(
    SettingsCache.settings.Features.includes('Support') ? `${tenant}/refunds/background` : null,
    async () => {
      const res = requireBackgroundTaskSuccess(
        await backgroundFetch<GetRefundsResponse>(getApiPath(tenant, `/refund`), 'refunds'),
        'refunds'
      );

      if (res?.success && res.result) {
        return res.result.refunds;
      }
      return null;
    },
    backgroundTaskSwrConfig
  );

  useEffect(() => {
    if (data?.length > 0) {
      data.forEach((x) => {
        if (!ExtendedOrderCache.refundOrderLineIds.find((c) => c.orderlineId.toString() === x.orderLineId.toString())) {
          const created = new Date(x.created);
          ExtendedOrderCache.refundOrderLineIds.push({
            orderlineId: x.orderLineId.toString(),
            created: isNaN(created.getTime()) ? undefined : created,
            status: x.status,
            amount: x.amount
          });
        }
      });
    }
  }, [data]);

  return data;
};

export default useSupportBackgroundTask;
